module.exports = __webpack_public_path__ + "static/img/u210.86a4094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u210.png
// module id = GhD1
// module chunks = 0